import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import { Field } from 'redux-form';
class UserEmailOption extends Component {
    constructor(props) {
        super(props);
        this.onClickCloseAddName = () => {
            this.setState({ isOpen: false, nameValue: '' });
        };
        this.onChangeName = (e) => {
            this.setState({ nameValue: e.target.value });
        };
        this.onBlurAddNameBtn = () => {
            if (this.state.nameValue && this.state.nameValue.trim() !== '') {
                this.props.change(`${this.props.fields.name}[${this.props.index}].user.display_name`, this.state.nameValue);
                this.setState({ isOpen: false });
            }
        };
        this.onClickAddNameInput = () => {
            if (this.state.nameValue && this.state.nameValue.trim() !== '') {
                this.props.change(`${this.props.fields.name}[${this.props.index}].user.display_name`, this.state.nameValue);
                this.setState({ isOpen: false, nameValue: '' });
            }
            else {
                this.setState({ isOpen: false });
            }
        };
        this.onClickEditName = () => {
            this.setState({ isOpen: true });
        };
        this.state = {
            isOpen: false,
            nameValue: '',
        };
    }
    componentDidMount() {
        const field = this.props.fields.get(this.props.index);
        let nameValue = '';
        if ((field.user.name && typeof field.user.name === 'string') ||
            (field.user.display_name && typeof field.user.display_name === 'string')) {
            nameValue = field.user.display_name
                ? field.user.display_name
                : field.user.name
                    ? field.user.name
                    : '';
        }
        this.setState({ nameValue: nameValue });
    }
    componentDidUpdate() {
        const field = this.props.fields.get(this.props.index);
        let nameValue = '';
        if (this.state.nameValue === '') {
            if ((field.user.name && typeof field.user.name === 'string') ||
                (field.user.display_name && typeof field.user.display_name === 'string')) {
                nameValue = field.user.display_name
                    ? field.user.display_name
                    : field.user.name
                        ? field.user.name
                        : '';
            }
            if (nameValue !== '') {
                this.setState({ nameValue: nameValue });
            }
        }
    }
    render() {
        const { fields, index, contactField, fieldLabel, removable } = this.props;
        const field = contactField ? { user: contactField } : fields.get(index);
        let name = null;
        let fieldLabelHtml = null;
        let nameKey = 'name';
        if ((field.user.name && typeof field.user.name === 'string') ||
            (field.user.display_name && typeof field.user.display_name === 'string')) {
            name = field.user.display_name
                ? field.user.display_name
                : field.user.name
                    ? field.user.name
                    : null;
        }
        if (field.user.id && field.user.display_name) {
            nameKey = 'display_name';
        }
        if (fieldLabel) {
            fieldLabelHtml = (_jsx("label", { children: fieldLabel + (removable === false ? ' *' : '') }));
        }
        const displayname = name !== null ? `${name} <${field.user.email}>` : field.user.email;
        return (_jsx("div", Object.assign({ className: "selected-email field-action" }, { children: _jsxs("div", Object.assign({ className: "selected-email-label" }, { children: [_jsx(Tooltip, Object.assign({ content: displayname, dark: true }, { children: _jsxs("span", Object.assign({ className: "label-email" }, { children: [fieldLabelHtml, displayname, _jsx("button", Object.assign({ type: "button", className: "edit-btn-user-name hidden", onClick: this.onClickEditName }, { children: _jsx(DixaIcon, { icon: "customize" }) }))] })) })), _jsxs("div", Object.assign({ className: `add-name ${this.state.isOpen === true ? '' : 'hidden'}` }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn remove-btn remove-name-btn", onClick: this.onClickCloseAddName }, { children: _jsx(DixaIcon, { icon: "close" }) })), _jsxs("div", Object.assign({ className: "add-name-header" }, { children: [_jsx(DixaIcon, { icon: "user-plus", className: "header-plus-icon" }), _jsxs("span", Object.assign({ className: "add-name-header-text" }, { children: ["Add name to ", field.user.email] }))] })), _jsx(Field, { className: "add-name-input", type: "text", onChange: this.onChangeName, onBlur: this.onBlurAddNameBtn, name: `${contactField}.user.${nameKey}`, component: "input", placeholder: "" }), _jsx("button", Object.assign({ type: "button", className: "btn btn-add-name btn-primary outlined", onClick: this.onClickAddNameInput }, { children: "Add" }))] })), _jsx(Tooltip, Object.assign({ content: removable === true
                            ? `Remove ${field.user.email}`
                            : `${field.user.email} is the requester and can not be removed.`, dark: true }, { children: _jsx("button", Object.assign({ type: "button", className: 'btn remove-user-btn ' + (removable === true ? '' : 'disable'), onClick: removable === true
                                ? () => {
                                    fields.remove(index);
                                }
                                : () => {
                                    /** Noop. */
                                } }, { children: _jsx(DixaIcon, { icon: "close" }) })) }))] })) })));
    }
}
export default UserEmailOption;
